var _sodipodiNamedview, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompozzBoussoleVioletCentreC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    viewBox: "0 0 114 114",
    sodipodiDocname: "Compozz_boussole_violet_centre_C.svg",
    width: 114,
    height: 114,
    inkscapeVersion: "1.2.2 (b0a8486541, 2022-12-01)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview34",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeZoom: 5.4224638,
    inkscapeCx: 11.987171,
    inkscapeCy: 62.241079,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 1011,
    inkscapeWindowX: 1920,
    inkscapeWindowY: 32,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "Calque_2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .cls-1 {\n        fill: #654bf6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1",
    transform: "translate(0.84786445,0.39328387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 90.91,88.66 C 88.74,86.75 87.09,84.43 85.98,81.7 85.66,80.91 85.42,80.07 85.21,79.2 73.71,93.8 53.01,97.52 37.11,87.46 L 36.36,86.99 35.64,86.48 C 19.69,75.3 15.33,53.57 25.74,37.1 l 0.47,-0.75 0.51,-0.72 C 35.77,22.71 51.68,17.4 66.16,21.35 68.66,17.94 71.6,14.84 74.94,12.12 68.11,9.31 60.68,8.07 53.28,8.58 L 48.43,1.37 C 46.9,-0.9 43.39,-0.2 42.86,2.49 l -1.69,8.52 c -9.15,3.1 -17.19,8.96 -23,16.68 l -0.15,-0.1 -1.48,2.32 -1.57,2.26 0.15,0.1 C 10.23,40.61 7.93,50.28 8.59,59.92 l -7.24,4.87 c -2.26,1.52 -1.56,5.01 1.11,5.55 l 8.55,1.7 c 3.1,9.15 8.96,17.19 16.68,23 l -0.1,0.15 2.32,1.48 2.26,1.57 0.1,-0.15 c 8.34,4.89 18.01,7.19 27.66,6.53 l 4.86,7.23 c 1.52,2.26 5.02,1.56 5.56,-1.11 l 1.7,-8.54 c 7.55,-2.56 14.34,-7 19.76,-12.8 -0.3,-0.24 -0.61,-0.46 -0.9,-0.71 z",
    id: "path16"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompozzBoussoleVioletCentreC);
export default __webpack_public_path__ + "static/media/Compozz_boussole_violet_centre_C.f755ac34e961693349049f28a4e5dc93.svg";
export { ForwardRef as ReactComponent };